<template>
	<div class="configuration-workspace">
		<header class="configuration-switcher">
			<div class="configuration-switcher-copy">
				<small>GESTIÓN DE ACCESOS</small>
				<h1>{{ tabsModel === 0 ? 'Distribuidores' : 'Implementadores' }}</h1>
			</div>
			<nav class="configuration-segments" aria-label="Tipo de usuario">
				<button
					v-for="(item, index) in tabs"
					:key="item.id"
					type="button"
					:class="{ 'is-active': tabsModel === index }"
					@click="tabsModel = index"
				>
					<v-icon>{{ item.icon }}</v-icon>
					<span>{{ item.name }}</span>
				</button>
			</nav>
		</header>
		<main class="configuration-list-content">
			<dealers-list v-if="tabsModel === 0" />
			<implementers-list v-else />
		</main>
		<router-view></router-view>
	</div>
</template>
<script>
import dealersList from '@/components/configuration/dealers-list';
import implementersList from '@/components/configuration/implementers-list';

function created() {
	if (this.$route.name === 'page-config-implementers') {
		this.tabsModel = 1;
	} else if (this.$route.name === 'page-config-dealers') {
		this.tabsModel = 0;
	}
}

function tabsModel(value) {
	if (this.$route.meta.primary) {
		if (value === 0) {
			this.goTo('page-config-dealers');
		} else {
			this.goTo('page-config-implementers');
		}
	}
}

function newRoute(value) {
	if (value.name === 'page-config-dealers') {
		this.tabsModel = 0;
	} else if (value.name === 'page-config-implementers') {
		this.tabsModel = 1;
	}
}

function data() {
	return {
		tabsModel: null,
		tabs: [
			{
				id: 1,
				name: 'Distribuidores',
				icon: 'store_mall_directory',
			},
			{
				id: 2,
				name: 'Implementadores',
				icon: 'engineering',
			},
		],
	};
}

export default {
	name: 'page-list-configuration',
	data,
	created,
	components: {
		dealersList,
		implementersList,
	},
	watch: {
		tabsModel,
		$route: newRoute,
	},
};
</script>

<style lang="scss" scoped>
.configuration-workspace {
	background: #f5f8fb;
	min-height: calc(100vh - 102px);
	padding: 12px 16px 64px;
}

.configuration-switcher {
	align-items: center;
	background: white;
	border: 1px solid #dfe8f0;
	border-radius: 12px;
	box-shadow: 0 4px 14px rgba(31, 60, 88, .06);
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	min-height: 64px;
	padding: 8px 12px 8px 16px;
}

.configuration-switcher-copy {
	small { color: #2681cf; font-size: 8px; font-weight: 700; letter-spacing: .12em; }
	h1 { color: #263f57; font-size: 17px; margin: 2px 0 0; }
}

.configuration-segments {
	align-items: center;
	background: #eef3f7;
	border: 1px solid #e0e7ee;
	border-radius: 10px;
	display: flex;
	gap: 3px;
	padding: 3px;

	button {
		align-items: center;
		background: transparent;
		border: 0;
		border-radius: 8px;
		color: #65798c;
		cursor: pointer;
		display: inline-flex;
		font-size: 11px;
		font-weight: 600;
		gap: 6px;
		height: 34px;
		padding: 0 12px;
		transition: background .16s ease, box-shadow .16s ease, color .16s ease;
		.icon { color: #7d8fa0; font-size: 17px; }
		&:hover { background: rgba(255, 255, 255, .7); color: #1A4338; }
		&.is-active {
			background: white;
			box-shadow: 0 3px 9px rgba(31, 74, 113, .12);
			color: #1A4338;
			.icon { color: #1A4338; }
		}
	}
}

.configuration-list-content { width: 100%; }

@media (max-width: 700px) {
	.configuration-workspace { padding: 9px 9px 64px; }
	.configuration-switcher { align-items: stretch; flex-direction: column; gap: 9px; padding: 11px; }
	.configuration-segments { width: 100%; }
	.configuration-segments button { flex: 1; justify-content: center; padding: 0 7px; }
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-list-configuration.vue